import React from 'react';
export function Header() {
  return <header className="w-full bg-ivory py-4 px-6 flex flex-col md:flex-row items-center justify-between max-w-[1200px] mx-auto" data-id="element-57">
      <img src="https://cdn.magicpatterns.com/uploads/dYzVtL1eVSFYapkBViFR4r/LogoLegadoSalud.png" alt="Legado Salud Logo" className="h-16 md:h-20 object-contain mix-blend-multiply" data-id="element-58" />
      <p className="text-botanic font-serif italic text-sm md:text-base mt-2 md:mt-0 text-center" data-id="element-59">
        "Recupera tu energía, nutre tu cuerpo, transforma tu vida"
      </p>
    </header>;
}